module.exports = __webpack_public_path__ + "static/media/icon3.36aa3102.webp";